export default __webpack_public_path__ + "static/media/afficheBlur.00c74ea9.jpg";